import * as React from "react";
import { BetBtn } from "../BetBtn";
export class BetBtnRegular extends BetBtn {
    renderContent() {
        return (React.createElement("div", { className: `rj-ev-list__bet-btn__inner ${this.shouldRenderText() && this.shouldRenderPoints() ? "rj-ev-list__bet-btn__inner--full" : ""}`, "data-uat": "div-ev-list-bet-btn-inner" },
            React.createElement("div", { className: `rj-ev-list__bet-btn__row`, "data-uat": "div-ev-list-bet-btn-row" },
                this.renderText(),
                this.renderPoints()),
            React.createElement("div", { className: `rj-ev-list__bet-btn__row`, "data-uat": "div-ev-list-bet-btn-row" }, this.renderOdds())));
    }
}
//# sourceMappingURL=BetBtnRegular.js.map